export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Teclado"},
    mouse: {name: "Mouse"},
    webcam: {name: "Webcam"},
    headset: {name: "Fone de ouvido"},
    dockingStation: {name: "Docking Station"},
}